import { setCategories, setInstrument, setMenuSymbol } from '../../redux/reducer/instruments';

const extractCategories = (events) => {
  return events.reduce(
    (acc, event) => ({
      ...acc,
      [event.type]: event.type
    }),
    {}
  );
};

const findDefaultSymbol = (events) => {
  return events.find((event) => event.symbol.includes('XAUUSD'));
};

const createInitialMenuState = (accountId, symbolData) => {
  return {
    [accountId]: {
      menu: [
        {
          symbol: symbolData.symbol,
        }
      ],
      active: symbolData.symbol
    },
    accountId
  };
};

const handleExistingMenu = (prevMenu, accountId, firstSymbolData) => {
  try {
    const prevJson = JSON.parse(prevMenu);

    // Ensure prevJson is an object
    if (typeof prevJson !== 'object' || prevJson === null) {
      return createInitialMenuState(accountId, firstSymbolData);
    }

    if (!prevJson[accountId]) {
      // Create new account entry while preserving existing data
      return {
        ...prevJson,
        [accountId]: {
          menu: [
            {
              symbol: firstSymbolData.symbol,
            }
          ],
          active: firstSymbolData.symbol
        },
        accountId
      };
    }

    // Ensure the existing account data has the correct structure
    if (!Array.isArray(prevJson[accountId].menu)) {
      prevJson[accountId].menu = [];
    }
    if (!prevJson[accountId].active) {
      prevJson[accountId].active = firstSymbolData.symbol;
    }

    return {
      ...prevJson,
      accountId
    };
  } catch (error) {
    console.error('Error handling existing menu:', error);
    return createInitialMenuState(accountId, firstSymbolData);
  }
};

const initializeMenuSymbol = async ({ dispatch, listArray, setLoading, activeAccount }) => {
  try {
    if (!listArray?.length) {
      throw new Error('No events received');
    }

    // Extract categories and find default symbol
    const categories = extractCategories(listArray);
    const firstSymbolData = findDefaultSymbol(listArray);

    if (!firstSymbolData) {
      throw new Error('Default symbol XAUUSD not found');
    }

    // Update instruments and categories
    dispatch(setInstrument(listArray));
    dispatch(setCategories(categories));

    if (!activeAccount) {
      return;
    }

    // Handle menu storage logic
    const prevMenu = localStorage.getItem('symbol_menu_list');
    let menuState;

    if (prevMenu) {
      menuState = handleExistingMenu(prevMenu, activeAccount, firstSymbolData);
    } else {
      menuState = createInitialMenuState(activeAccount, firstSymbolData);
    }

    // Always save to localStorage and dispatch
    localStorage.setItem('symbol_menu_list', JSON.stringify(menuState));
    dispatch(
      setMenuSymbol({
        type: prevMenu ? 'old' : 'first',
        data: menuState,
        active: activeAccount
      })
    );
    setLoading(false);
  } catch (error) {
    console.error('Error initializing menu symbol:', error);
  }
};

export default initializeMenuSymbol;
